export const CurtainsFabricDetails = [
  {
    brand_0: '',
    header_style_0: '',
  }
];

export const CurtainsHardwareDetails = [
  {
    hardware_type_0: '',
    type_0: '',
    finial_design_0: '',
    rod_colour_0: '',
    length_0: '',
  },
];

export const PanelDetails = [
  {
    panel_name_0: '',
    fabric_name_0: '',
    panel_type_0: '',
    lining_0: '',
    panel_width_0: '',
    panel_height_0: '',
    quantity_0: '',
  }
];


export const CurtainsYellowDetails = [
  {
    fabric_name_0: '',
    wall_orientation__0: '',
    quantity_0: '',
    hardware_type_0: '',
    lining_0: '',
    panel_height_0: '',
    curtains_height_0: '',
  },
];

export const CurtainsDecorDetails = [
  {
    fabric_name_0: '',
    wall_orientation__0: '',
    quantity_0: '',
    length_0: '',
  },
];


export const CurtainsAumbreDetails = [
  {
    sku_code_0: '',
    fabric_name_0: '',
    quantity_0: '',
    uom_0: '',
    type_0: '',
    wall_orientation_0: '',
    window_door_height_0: '',
    hardware_details_0: '',
    final_details_0: '',
  },
];